import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { DialogButton, CrawfordDialogComponent, CrawfordSnackbarService, ICustomValidation } from 'crawford-shell';
import { UserService } from '../user.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  @ViewChild('changePasswordDialog') private dialog: CrawfordDialogComponent;

  public changePasswordForm: FormGroup;
  public dialogButtons = [
    new DialogButton(this.updatePassword.bind(this), { content: 'Save', isPrimary: true }),
    new DialogButton(this.cancelForm.bind(this), { content: 'Cancel', isPrimary: false })
  ];
  public validationMessages: ICustomValidation[] = [];

  constructor(private formBuilder: FormBuilder,
    private snackbarService: CrawfordSnackbarService,
    private userService: UserService) {

  }

  ngOnInit() {
    this.createChangePasswordForm();

    this.userService.onOpenChangePasswordDialog.subscribe(x => this.openDialog());
  }

  private createChangePasswordForm(): any {
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', [Validators.required,
                                        Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]),
      confirmPassword: new FormControl('', [Validators.required])
    });

    this.validationMessages.push({
      controlName: 'oldPassword',
      errorType: 'required',
      customMessage: 'The current password is required'
    });

    this.validationMessages.push({
      controlName: 'newPassword',
      errorType: 'required',
      customMessage: 'A new password is required'
    });

    this.validationMessages.push({
      controlName: 'newPassword',
      errorType: 'pattern',
      customMessage: 'The new password is invalid: please see the instructions above'
    });

    this.validationMessages.push({
      controlName: 'confirmPassword',
      errorType: 'required',
      customMessage: 'The new password confirmation is required'
    });
  }

  public openDialog() {
    this.dialog.showDialog();
  }

  public updatePassword(): void {
    this.userService.changePassword(this.changePasswordForm.value).subscribe(x => {
      this.snackbarService.displaySuccessMessage('Password Updated');
      this.userService.logout().subscribe();
    });
  }

  public cancelForm(): void {
    this.changePasswordForm.reset();
    this.dialog.hideDialog();
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/user/change-password/change-password.component.ts